module.exports = __webpack_public_path__ + "img/send.459c65af.svg";